const _jsxFileName = ""; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { useState, useEffect, useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedCollection from './components/FeaturedCollection';
import GridCategories from './components/GridCategories';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import VideoSection from './components/VideoSection';
import Contact from './components/Contact';
import Concierge from './components/Concierge';
import Services from './components/Services';
import About from './components/About';
import Auth from './components/Auth';
import Shop from './components/Shop';
import Checkout from './components/Checkout';
import AdminDashboard from './components/AdminDashboard';
import AdminProducts from './components/AdminProducts';
import AdminPricing from './components/AdminPricing';
import AdminProfile from './components/AdminProfile';
import AdminSettings from './components/AdminSettings';
import AdminMembers from './components/AdminMembers';
import AdminStaff from './components/AdminStaff';
import AdminTransactions from './components/AdminTransactions';
import MemberProfile from './components/MemberProfile';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProductDetailModal from './components/ProductDetailModal';

import ResetPassword from './components/ResetPassword';
import PaymentProofUpload from './components/PaymentProofUpload';
import AdminBankDetails from './components/AdminBankDetails';
import Wishlist from './components/Wishlist';


// API configuration
const API_BASE_URL = import.meta.env.VITE_API_URL;

// Define types for API responses














// Default site settings (fallback)
const DEFAULT_SITE_SETTINGS = {
  siteName: 'Sparkling Gems',
  siteDescription: 'Luxury jewelry and accessories',
  contactEmail: 'rsgleamofgolds@gmail.com',
  contactPhone: '0945 392 8946',
  address: '2F, San Antonio Building, Corumi, Quezon City, 1012 Metro Manila',
  currency: 'PHP',
  taxRate: 0.12,
  email: 'rsgleamofgolds@gmail.com',
  phone: '0945 392 8946',
  hours: 'Mon-Sun: 9am - 8pm',
  facebook_url: 'https://www.facebook.com/sparkling1gems',
  instagram_url: 'https://www.instagram.com/sparkling1gems',
  shipping_fee: 0,
  free_shipping_threshold: 5000
};

// Use more reliable placeholder service
const PLACEHOLDER_IMAGE = 'https://placehold.co/400x400/f5f5f5/999999?text=No+Image';

// ============================================================
// FIXED: getCleanImageUrl - KEEPS all valid images, including base64
// ============================================================
const getCleanImageUrl = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== 'string') return '';

  const trimmed = imageUrl.trim();
  if (!trimmed) return '';

  // Keep valid base64 images (these are legitimate uploaded images)
  if (trimmed.startsWith('data:image/')) {
    // Fix malformed base64 if needed
    let fixed = trimmed;
    if (fixed.includes(':base64') && !fixed.includes(';base64')) {
      fixed = fixed.replace(':base64', ';base64,');
    }
    if (fixed.includes(';base64') && !fixed.includes(';base64,')) {
      fixed = fixed.replace(';base64', ';base64,');
    }
    return fixed;
  }

  // Keep blob URLs (temporary URLs from file selection)
  if (trimmed.startsWith('blob:')) {
    return trimmed;
  }

  // Keep full absolute URLs
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  // Keep protocol-relative URLs
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }

  // Convert relative paths to absolute URLs
  if (trimmed.startsWith('/')) {
    const SITE_BASE_URL = import.meta.env.VITE_API_URL.replace('/api','');
    return `${SITE_BASE_URL}${trimmed}`;
  }

  // Default: treat as relative path from root
  const SITE_BASE_URL = import.meta.env.VITE_API_URL.replace('/api','');
  return `${SITE_BASE_URL}/${trimmed}`;
};

// Helper functions for tier calculation
const calculatePointsFromSpent = (totalSpent) => {
  return Math.floor(totalSpent / 100);
};

const getTierFromPoints = (points) => {
  if (points >= 50000) return 'Diamond';
  if (points >= 15000) return 'Emerald';
  if (points >= 5000) return 'Ruby';
  return 'Sapphire';
};

// Helper function to safely parse weight
const parseWeight = (weight) => {
  if (weight === undefined || weight === null) return NaN;
  
  let weightStr;
  if (typeof weight === 'number') {
    weightStr = weight.toString();
  } else {
    weightStr = weight;
  }
  
  // Remove 'g' suffix and any other non-numeric characters except decimal point
  const cleaned = weightStr.replace(/[^0-9.]/g, '');
  const parsed = parseFloat(cleaned);
  
  return isNaN(parsed) ? NaN : parsed;
};

function App() {
  const [activePage, setActivePage] = useState(() => {
    const path = window.location.pathname;
    const map = {
      '/': 'home', '/home': 'home', '/shop': 'shop', '/collections': 'collections',
      '/bags': 'bags', '/fragrances': 'fragrances', '/checkout': 'checkout',
      '/contact': 'contact', '/services': 'services', '/about': 'about',
      '/privacy-policy': 'privacy-policy', '/auth': 'auth', '/register': 'register',
      '/reset-password': 'reset-password', '/profile': 'profile', '/orders': 'orders',
      '/upload-proof': 'upload-proof', '/admin-login': 'admin-portal', '/login-admin': 'admin-portal',
      '/admin/dashboard': 'admin-dashboard', '/admin/products': 'admin-products',
      '/admin/add-product': 'admin-add-product', '/admin/pricing': 'admin-pricing',
      '/admin/profile': 'admin-profile', '/admin/settings': 'admin-settings',
      '/admin/members': 'admin-members', '/admin/transactions': 'admin-transactions',
      '/admin/bank-details': 'admin-bank-details',
    };
    if (path.startsWith('/admin/')) {
      const seg = path.replace('/admin/', '');
      const adminMap = {
        'dashboard': 'admin-dashboard', 'products': 'admin-products',
        'add-product': 'admin-add-product', 'pricing': 'admin-pricing',
        'profile': 'admin-profile', 'settings': 'admin-settings',
        'members': 'admin-members', 'transactions': 'admin-transactions',
        'bank-details': 'admin-bank-details',
      };
      return adminMap[seg] || 'home';
    }
    return map[path] || 'home';
  });
  const [resetToken, setResetToken] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('token') || '';
  });
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('sparklingUser');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [products, setProducts] = useState([]);
  const [rates, setRates] = useState([]);
  const [siteSettings, setSiteSettings] = useState(DEFAULT_SITE_SETTINGS);
  const [members, setMembers] = useState([]);
  
  // Global Order State
  const [allOrders, setAllOrders] = useState([]);
  
  // Wishlist, Cart & Modal State
  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  
  // State for direct checkout from product modal or wishlist
  const [directCheckoutItem, setDirectCheckoutItem] = useState(null);
  const [wishlistCheckoutItems, setWishlistCheckoutItems] = useState(null);

  // Loading states
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [dataSources, setDataSources] = useState({});
  
  // Image error tracking
  const [imageErrors, setImageErrors] = useState({});

  // Cart and Wishlist counts for navbar
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);

  // Overlay states for cart and wishlist
  const [showCart, setShowCart] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);

  // Global toast notification
  const [toast, setToast] = useState(null);
  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  // Prevent duplicate wishlist clicks per product
  const wishlistProcessingRef = useRef(new Set());

  // URL to Page mapping
  const pathToPage = {
    '/': 'home',
    '/home': 'home',
    '/shop': 'shop',
    '/collections': 'collections',
    '/bags': 'bags',
    '/fragrances': 'fragrances',
    '/checkout': 'checkout',
    '/contact': 'contact',
    '/services': 'services',
    '/about': 'about',
    '/privacy-policy': 'privacy-policy',
    '/auth': 'auth',
    '/register': 'register',
    '/reset-password': 'reset-password',
    '/profile': 'profile',
    '/orders': 'orders',
    '/upload-proof': 'upload-proof',
    '/admin/dashboard': 'admin-dashboard',
    '/admin/products': 'admin-products',
    '/admin/add-product': 'admin-add-product',
    '/admin/pricing': 'admin-pricing',
    '/admin/profile': 'admin-profile',
    '/admin/settings': 'admin-settings',
    '/admin/members': 'admin-members',
    '/admin/transactions': 'admin-transactions',
    '/admin/bank-details': 'admin-bank-details',
    '/admin-login': 'admin-portal',
    '/login-admin': 'admin-portal',
  };

  // Initialize page from URL on load
  useEffect(() => {
    const path = window.location.pathname;
    const savedPage = localStorage.getItem('sparklingActivePage');
    
    // Check if it's an admin route with /admin/ prefix
    if (path.startsWith('/admin/') || path === '/admin-login' || path === '/login-admin') {
      const savedUser = localStorage.getItem('sparklingUser');
      const currentUser = savedUser ? JSON.parse(savedUser) : null;
      // Block access if not admin or staff
      if (!currentUser || (currentUser.role !== 'admin' && currentUser.role !== 'staff')) {
        setActivePage('home');
        window.history.replaceState(null, '', '/');
        return;
      }
      const adminPage = path.replace('/admin/', '');
      const pageMap = {
        'dashboard': 'admin-dashboard',
        'products': 'admin-products',
        'add-product': 'admin-add-product',
        'pricing': 'admin-pricing',
        'profile': 'admin-profile',
        'settings': 'admin-settings',
        'members': 'admin-members',
        'transactions': 'admin-transactions',
        'bank-details': 'admin-bank-details'
      };
      if (pageMap[adminPage]) {
        setActivePage(pageMap[adminPage]);
        return;
      }
    }
    
    // Check for direct matches
    if (pathToPage[path]) {
      const pageToSet = pathToPage[path];
      
      // Protect member-only routes
      const protectedRoutes = ['profile', 'orders', 'upload-proof'];
      if (protectedRoutes.includes(pageToSet)) {
        const savedUser = localStorage.getItem('sparklingUser');
        const currentUser = savedUser ? JSON.parse(savedUser) : null;
        
        // Redirect to login if not authenticated
        if (!currentUser) {
          setActivePage('auth');
          window.history.replaceState(null, '', '/auth');
          return;
        }
      }
      
      setActivePage(pageToSet);
    } 
    // Check for saved admin page
    else if (savedPage && savedPage.startsWith('admin-')) {
      setActivePage(savedPage);
      // Update URL to match
      const adminPath = savedPage.replace('admin-', '');
      window.history.replaceState(null, '', `/admin/${adminPath}`);
    }
  }, []);

  // Update URL when activePage changes
  useEffect(() => {
    // Save to localStorage for persistence across reloads
    localStorage.setItem('sparklingActivePage', activePage);

    // Update URL based on page
    const pageToPath = {
      'home': '/',
      'shop': '/shop',
      'collections': '/collections',
      'bags': '/bags',
      'fragrances': '/fragrances',
      'checkout': '/checkout',
      'contact': '/contact',
      'services': '/services',
      'about': '/about',
      'privacy-policy': '/privacy-policy',
      'auth': '/auth',
      'register': '/register',
      'reset-password': '/reset-password',
      'profile': '/profile',
      'orders': '/orders',
      'upload-proof': '/upload-proof',
      'admin-dashboard': '/admin/dashboard',
      'admin-products': '/admin/products',
      'admin-add-product': '/admin/add-product',
      'admin-pricing': '/admin/pricing',
      'admin-profile': '/admin/profile',
      'admin-settings': '/admin/settings',
      'admin-members': '/admin/members',
      'admin-transactions': '/admin/transactions',
      'admin-bank-details': '/admin/bank-details',
      'admin-portal': '/admin-login',
    };

    const path = pageToPath[activePage];
    if (path && window.location.pathname !== path) {
      window.history.pushState(null, '', path);
    }
  }, [activePage]);

  // Protect member-only routes when user is not logged in
  useEffect(() => {
    const protectedRoutes = ['profile', 'orders', 'upload-proof'];
    
    if (protectedRoutes.includes(activePage) && !user) {
      setActivePage('auth');
      window.history.replaceState(null, '', '/auth');
    }
  }, [activePage, user]);

  // Update counts when cart/wishlist change
  useEffect(() => {
    setCartCount(cart.length);
  }, [cart]);

  useEffect(() => {
    setWishlistCount(wishlist.length);
  }, [wishlist]);

  // Listen for storage events from Cart/Wishlist components
  // [user] dep ensures fresh closure so login/logout don't leave stale handlers
  useEffect(() => {
    const handleStorageChange = () => {
      loadWishlistFromDatabase();
      loadCartFromDatabase();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [user]);

  // Listen for cartCleared event
  useEffect(() => {
    const handleCartCleared = () => {
      loadCartFromDatabase();
      setDirectCheckoutItem(null);
      setWishlistCheckoutItems(null);
    };

    window.addEventListener('cartCleared', handleCartCleared);
    return () => window.removeEventListener('cartCleared', handleCartCleared);
  }, [user]);

  // Listen for wishlist-updated event
  // [user] dep ensures fresh closure so re-login always loads the correct user's wishlist
  useEffect(() => {
    const handleWishlistUpdated = () => {
      loadWishlistFromDatabase();
    };

    window.addEventListener('wishlist-updated', handleWishlistUpdated);
    return () => window.removeEventListener('wishlist-updated', handleWishlistUpdated);
  }, [user]);

  // Handle wishlist checkout data when navigating to checkout
  useEffect(() => {
    if (activePage === 'checkout') {
      const wishlistCheckout = sessionStorage.getItem('wishlistCheckout');
      if (wishlistCheckout) {
        try {
          const data = JSON.parse(wishlistCheckout);
          if (data.source === 'wishlist' && data.items && data.items.length > 0) {
            
            // Convert wishlist items to cart items for checkout
            const checkoutItems = data.items.map((item) => ({
              id: item.product.id,
              cart_id: item.product.id,
              name: item.product.name,
              price: item.product.price,
              image: item.product.image,
              category: item.product.category,
              description: item.product.description,
              quantity: item.quantity,
              selected: true,
              stock: item.product.stock,
              total: item.product.price * item.quantity
            }));
            
            setWishlistCheckoutItems(checkoutItems);
          }
        } catch (e) {
        }
      }
    } else {
      // Clear wishlist checkout items when leaving checkout
      setWishlistCheckoutItems(null);
    }
  }, [activePage]);

  // Fetch all data on app load
  useEffect(() => {
    const loadAllData = async () => {
      await fetchProductsFromDatabase();
      await fetchGoldRatesFromDatabase();
      await fetchSiteSettingsFromDatabase();
      await fetchMembersFromDatabase();
      
      // Load wishlist and cart after products are loaded
      loadWishlistFromDatabase();
      loadCartFromDatabase();
      
      // Fetch orders AFTER user is loaded
      await fetchOrdersFromDatabase();
    };
    
    loadAllData();
  }, []);

  // Reload wishlist, cart, and orders when user changes
  useEffect(() => {
    if (products.length > 0) {
      loadWishlistFromDatabase();
      loadCartFromDatabase();
      fetchOrdersFromDatabase();
    }
  }, [user]);

  // Save user to localStorage whenever it changes
  useEffect(() => {
    if (user) {
      localStorage.setItem('sparklingUser', JSON.stringify(user));
    } else {
      localStorage.removeItem('sparklingUser');
    }
  }, [user]);

  // Generate a consistent guest ID
  const getGuestId = () => {
    let guestId = localStorage.getItem('guest_id');
    if (!guestId) {
      guestId = 'guest_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('guest_id', guestId);
    } else {
    }
    return guestId;
  };

  // Get user ID if logged in — reads localStorage as fallback so event-listener
  // closures (which capture a stale `user`) still return the correct ID.
  const getUserId = () => {
    if (_optionalChain([user, 'optionalAccess', _ => _.id])) return user.id;
    try {
      const saved = localStorage.getItem('sparklingUser');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (_optionalChain([parsed, 'optionalAccess', _2 => _2.id])) return parsed.id;
      }
    } catch (e) {}
    return null;
  };

  // ============================================================
  // FIXED: fetchProductsFromDatabase - KEEPS all valid images
  // ============================================================
  const fetchProductsFromDatabase = async () => {
    try {
      setIsLoading(true);
      setApiError(null);
      
      const isAdmin = user?.role === 'admin';
      const response = await fetch(`${API_BASE_URL}/products${isAdmin ? '?admin=true&limit=100' : ''}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && Array.isArray(result.data)) {
        if (result.data.length > 0) {
          const normalizedProducts = result.data.map((item) => {
            // Get image from all possible sources
            const imageSource = item.image_url || item.image || item.mainImage || item.product_image || '';
            const resolvedImage = getCleanImageUrl(imageSource);
            
            const hoverSource = item.hover_image || item.hoverImage || '';
            const resolvedHover = getCleanImageUrl(hoverSource);
            
            // Process gallery images
            let resolvedGallery = [];
            const gallerySource = item.galleryImages || item.gallery_images;
            if (Array.isArray(gallerySource)) {
              resolvedGallery = gallerySource
                .map((img) => getCleanImageUrl(img))
                .filter(Boolean);
            } else if (typeof gallerySource === 'string' && gallerySource.length > 20) {
              try {
                const parsed = JSON.parse(gallerySource);
                if (Array.isArray(parsed)) {
                  resolvedGallery = parsed
                    .map((img) => getCleanImageUrl(img))
                    .filter(Boolean);
                }
              } catch (e) {
                resolvedGallery = gallerySource
                  .split(',')
                  .map((img) => getCleanImageUrl(img.trim()))
                  .filter(Boolean);
              }
            }
            
            
            return {
              id: item.id,
              name: item.name || '',
              description: item.description || '',
              price: typeof item.price === 'string' ? parseFloat(item.price) : (item.price || 0),
              image: resolvedImage || '',
              image_url: resolvedImage || '',
              hoverImage: resolvedHover || '',
              hover_image: resolvedHover || '',
              galleryImages: resolvedGallery,
              gallery_images: resolvedGallery,
              category: item.category || 'jewelry',
              isNew: item.is_new === 1 || item.isNew === true,
              isBestSeller: item.is_best_seller === 1 || item.isBestSeller === true,
              condition: item.condition || 'Brand New',
              weight: item.weight || '',
              karat: item.karat || '',
              goldType: item.gold_type || item.goldType || item.type || 'Standard',
              stock: typeof item.stock === 'string' ? parseInt(item.stock) : (item.stock || 0),
              sku: item.sku || '',
              slug: item.slug || '',
              short_description: item.short_description || item.description || '',
              compare_at_price: item.compare_at_price || 0,
              is_featured: item.is_featured === 1 || item.isFeatured === true,
              status: item.status || 'active',
              views_count: item.views_count || 0,
              created_at: item.created_at || '',
              updated_at: item.updated_at || '',
              is_promo: item.is_promo === 1 || item.is_promo === true,
              promo_price: item.promo_price ? parseFloat(item.promo_price) : null,
              promo_percentage: item.promo_percentage ? parseInt(item.promo_percentage) : null,
              promo_label: item.promo_label || null,
              promo_start_date: item.promo_start_date || null,
              promo_end_date: item.promo_end_date || null,
              isPreOrder: item.isPreOrder === 1 || item.isPreOrder === true,
              preOrderReleaseDate: item.preOrderReleaseDate || null,
              priceOverridden: item.priceOverridden === 1 || item.priceOverridden === true
            };
          });
          
          setProducts(normalizedProducts);
          
          if (result.source) {
            setDataSources(prev => ({ ...prev, products: result.source }));
          }
        } else {
        }
      } else {
      }
    } catch (error) {
      let errorMessage = 'Failed to load products';
      if (error instanceof Error) {
        errorMessage = `Failed to load products: ${error.message}`;
      }
      setApiError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  
  // ============================================================
  // FIXED: loadWishlistFromDatabase - PRESERVES all image formats including base64
  // ============================================================
  const loadWishlistFromDatabase = async () => {
    const userId = getUserId();
    const guestId = getGuestId();
    
    
    try {
      const url = userId 
        ? `${API_BASE_URL}/wishlist/get?user_id=${userId}&_=${Date.now()}`
        : `${API_BASE_URL}/wishlist/get?guest_id=${guestId}&_=${Date.now()}`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        
        const wishlistItems = data.data.map((item) => {
          // CRITICAL: Try ALL possible image sources in priority order
          let imageUrl = '';
          
          // Priority 1: product_image_url from joined products table (MOST RELIABLE)
          if (item.product_image_url && typeof item.product_image_url === 'string' && item.product_image_url.trim() !== '') {
            imageUrl = item.product_image_url;
          }
          // Priority 2: image_url field
          else if (item.image_url && typeof item.image_url === 'string' && item.image_url.trim() !== '') {
            imageUrl = item.image_url;
          }
          // Priority 3: product_image from wishlist snapshot
          else if (item.product_image && typeof item.product_image === 'string' && item.product_image.trim() !== '') {
            imageUrl = item.product_image;
          }
          // Priority 4: image field
          else if (item.image && typeof item.image === 'string' && item.image.trim() !== '') {
            imageUrl = item.image;
          }
          // Priority 5: db_image_url (legacy)
          else if (item.db_image_url && typeof item.db_image_url === 'string' && item.db_image_url.trim() !== '') {
            imageUrl = item.db_image_url;
          }
          // Priority 6: db_image (legacy)
          else if (item.db_image && typeof item.db_image === 'string' && item.db_image.trim() !== '') {
            imageUrl = item.db_image;
          }
          
          // Use getCleanImageUrl to KEEP all valid images (base64, blob, http)
          const resolvedImage = getCleanImageUrl(imageUrl);
          
          return {
            id: item.product_id || item.id,
            wishlist_id: item.id,
            name: item.product_name || item.name || item.db_name || 'Unknown Product',
            price: parseFloat(item.product_price || item.price) || 0,
            image: resolvedImage,
            image_url: resolvedImage,
            category: item.product_category || item.category || '',
            description: item.product_description || item.description || '',
            stock: item.stock || 0,
            condition: item.condition || 'Brand New',
            karat: item.karat || '',
            goldType: item.goldType || '',
            weight: item.weight || '',
            isNew: item.isNew || false,
            isBestSeller: item.isBestSeller || false,
            is_promo: item.is_promo || false,
            promo_price: item.promo_price || null,
            promo_percentage: item.promo_percentage || null,
            promo_label: item.promo_label || null,
            promo_end_date: item.promo_end_date || null,
            quantity: item.quantity || 1,
            selected: item.selected === 1 || false
          };
        });
        
        setWishlist(wishlistItems);
      } else {
        setWishlist([]);
      }
    } catch (error) {
      setWishlist([]);
    }
  };

  // ============================================================
  // FIXED: loadCartFromDatabase - PRESERVES all image formats
  // ============================================================
  const loadCartFromDatabase = async () => {
    const userId = getUserId();
    const guestId = getGuestId();
    
    
    try {
      const url = userId 
        ? `${API_BASE_URL}/cart/get?user_id=${userId}&_=${Date.now()}`
        : `${API_BASE_URL}/cart/get?guest_id=${guestId}&_=${Date.now()}`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        
        const cartItems = data.data.map((item) => {
          let imageUrl = '';
          
          // Priority 1: product_image_url from joined products table
          if (item.product_image_url && typeof item.product_image_url === 'string' && item.product_image_url.trim() !== '') {
            imageUrl = item.product_image_url;
          }
          // Priority 2: image_url field
          else if (item.image_url && typeof item.image_url === 'string' && item.image_url.trim() !== '') {
            imageUrl = item.image_url;
          }
          // Priority 3: product_image from cart snapshot
          else if (item.product_image && typeof item.product_image === 'string' && item.product_image.trim() !== '') {
            imageUrl = item.product_image;
          }
          // Priority 4: image field
          else if (item.image && typeof item.image === 'string' && item.image.trim() !== '') {
            imageUrl = item.image;
          }
          // Priority 5: db_image_url (legacy)
          else if (item.db_image_url && typeof item.db_image_url === 'string' && item.db_image_url.trim() !== '') {
            imageUrl = item.db_image_url;
          }
          // Priority 6: db_image (legacy)
          else if (item.db_image && typeof item.db_image === 'string' && item.db_image.trim() !== '') {
            imageUrl = item.db_image;
          }
          
          const resolvedImage = getCleanImageUrl(imageUrl);
          
          return {
            id: item.product_id || item.id,
            cart_id: item.id,
            name: item.product_name || item.name || item.db_name || 'Unknown Product',
            price: parseFloat(item.product_price || item.price) || 0,
            image: resolvedImage,
            image_url: resolvedImage,
            category: item.product_category || item.category || '',
            description: item.product_description || item.description || '',
            quantity: parseInt(item.quantity) || 1,
            selected: item.selected === 1 || false,
            stock: item.stock != null ? parseInt(item.stock) : null,
            total: (parseFloat(item.product_price || item.price) || 0) * (parseInt(item.quantity) || 1)
          };
        });
        
        setCart(cartItems);
      } else {
        setCart([]);
      }
    } catch (error) {
      setCart([]);
    }
  };

  // Sync wishlist with database
  const syncWishlistWithDatabase = async (product, action) => {
    const userId = getUserId();
    const guestId = getGuestId();
    
    try {
      const endpoint = action === 'add' ? 'add' : 'remove';
      
      // Get clean image URL - PRESERVE the actual image
      const cleanImageUrl = getCleanImageUrl(product.image);
      
      const requestBody = {
        user_id: userId,
        guest_id: guestId,
        product_id: product.id
      };
      
      if (action === 'add') {
        requestBody.product_data = {
          name: product.name,
          price: product.price,
          description: product.description || '',
          category: product.category || '',
          image_url: cleanImageUrl,
          image: cleanImageUrl,
          stock: product.stock || 0,
          condition: product.condition || 'Brand New',
          karat: product.karat || '',
          goldType: product.goldType || '',
          weight: product.weight || '',
          isNew: product.isNew || false,
          isBestSeller: product.isBestSeller || false,
          is_promo: (product ).is_promo || false,
          promo_price: (product ).promo_price || null,
          isPreOrder: (product ).isPreOrder || false
        };
      }
      
      const response = await fetch(`${API_BASE_URL}/wishlist/${endpoint}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      
      const data = await response.json();
      if (!response.ok || !data.success) {
        return false;
      }
      await loadWishlistFromDatabase();
      return true;
    } catch (error) {
      return false;
    }
  };

  // Bulk remove wishlist items
  const bulkRemoveWishlistItems = async (productIds) => {
    const userId = getUserId();
    const guestId = getGuestId();
    
    if (!productIds.length) return true;
    
    try {
      const response = await fetch(`${API_BASE_URL}/wishlist/remove-bulk`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          guest_id: guestId,
          product_ids: productIds
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        await loadWishlistFromDatabase();
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  // Sync cart with database
  const syncCartWithDatabase = async (product, quantity, action) => {
    const userId = getUserId();
    const guestId = getGuestId();
    
    try {
      let response;
      let endpoint = '';
      
      if (action === 'remove') {
        endpoint = 'remove';
        response = await fetch(`${API_BASE_URL}/cart/${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            guest_id: guestId,
            product_id: product.id
          })
        });
      } else if (action === 'update') {
        endpoint = 'update-quantity';
        response = await fetch(`${API_BASE_URL}/cart/${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            guest_id: guestId,
            product_id: product.id,
            quantity: quantity
          })
        });
      } else {
        endpoint = 'add';
        const cleanImageUrl = getCleanImageUrl(product.image);
        
        response = await fetch(`${API_BASE_URL}/cart/${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            guest_id: guestId,
            product_id: product.id,
            product_data: {
              name: product.name,
              price: product.price,
              description: product.description || '',
              category: product.category || '',
              image_url: cleanImageUrl,
              image: cleanImageUrl,
              stock: product.stock || 0,
              condition: product.condition || 'Brand New'
            },
            quantity: quantity
          })
        });
      }
      
      if (!response.ok) {
        return false;
      }
      
      const data = await response.json();
      
      if (data.success && (action === 'add' || action === 'remove')) {
        setTimeout(() => {
          loadCartFromDatabase();
        }, 100);
      }
      
      // Important: For update action, we need to ensure success is properly returned
      const success = data.success === true;
      return success;
    } catch (error) {
      return false;
    }
  };
  
  // Fetch gold rates from database
  const fetchGoldRatesFromDatabase = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/gold-rates`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && Array.isArray(result.data)) {
        if (result.data.length > 0) {
          const mappedRates = result.data.map((item) => ({
            id: item.id,
            goldType: item.goldType || item.gold_type,
            karat: item.karat,
            pricePerGram: item.pricePerGram || item.price_per_gram,
            lastUpdated: item.last_updated || item.updated_at,
            metalType: item.metal_type || 'gold'
          }));
          
          setRates(mappedRates);
        }
      }
    } catch (error) {
      if (error instanceof Error) {
      }
    }
  };

  // Fetch site settings from database
  const fetchSiteSettingsFromDatabase = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/settings`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && result.data) {
        let settingsObj = {};
        
        if (Array.isArray(result.data)) {
          settingsObj = (result.data ).reduce((acc, item) => {
            return { ...acc, [item.setting_key]: item.setting_value };
          }, {});
        } else if (typeof result.data === 'object') {
          settingsObj = result.data ;
        }
        
        setSiteSettings({ ...DEFAULT_SITE_SETTINGS, ...settingsObj });
      }
    } catch (error) {
      if (error instanceof Error) {
      }
    }
  };

  // Fetch members from database
  const fetchMembersFromDatabase = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/members`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && Array.isArray(result.data)) {
        if (result.data.length > 0) {
          const filteredMembers = result.data
            .filter((m) => m.role !== 'admin')
            .map((m) => {
              let points = m.points || 0;
              const totalSpent = m.total_spent || m.totalSpent || 0;
              
              if (points === 0 && totalSpent > 0) {
                points = calculatePointsFromSpent(totalSpent);
              }
              
              const tier = getTierFromPoints(points);
              
              return {
                id: m.id,
                name: m.name || m.first_name + ' ' + m.last_name || 'Member',
                email: m.email,
                phone: m.phone || '',
                avatar: m.avatar || '',
                role: m.role || 'member',
                membership_tier: tier,
                points: points,
                status: m.status || 'Active',
                totalSpent: totalSpent,
                ordersCount: m.orders_count || m.ordersCount || 0,
                joinDate: m.joinDate || _optionalChain([m, 'access', _8 => _8.created_at, 'optionalAccess', _9 => _9.split, 'call', _10 => _10('T'), 'access', _11 => _11[0]]) || new Date().toLocaleDateString(),
                created_at: m.created_at,
                last_login: m.last_login
              };
            });
          
          setMembers(filteredMembers);
        } else {
          setMembers([]);
        }
      } else {
        setMembers([]);
      }
    } catch (error) {
      setMembers([]);
    }
  };

  // Fetch orders from database
  const fetchOrdersFromDatabase = async () => {
    try {
      const userId = getUserId();
      
      const token = localStorage.getItem('sparklingToken');
      if (!token) { setAllOrders([]); return; }

      const isAdmin = _optionalChain([user, 'optionalAccess', _12 => _12.role]) !== 'member' && !!_optionalChain([user, 'optionalAccess', _12 => _12.role]);
      const url = isAdmin
        ? `${API_BASE_URL}/orders/get?admin=true`
        : `${API_BASE_URL}/orders/get`;

      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && Array.isArray(result.orders)) {
        const mappedOrders = result.orders.map((order) => ({
          ...order,
          total:           parseFloat(order.total_amount) || 0,
          totalAmount:     parseFloat(order.total_amount) || 0,
          order_date:      order.order_date || order.created_at,
          date:            order.order_date || order.created_at,
          deliveryType:    order.delivery_type || order.deliveryType || 'shipping',
          trackingNumber:  order.tracking_number || order.trackingNumber || '',
          paymentProof:    order.payment_proof || order.paymentProof || null,
          customerName:    order.customer_name || order.customerName || '',
          shippingAddress: order.shipping_address || order.shippingAddress || '',
          items:           typeof order.items === 'string' ? JSON.parse(order.items) : (order.items || [])
        }));
        setAllOrders(mappedOrders);
      } else if (result.success && Array.isArray(result.data)) {
        const mappedOrders = result.data.map((order) => ({
          ...order,
          deliveryType: order.deliveryType || order.delivery_type || 'shipping'
        }));
        setAllOrders(mappedOrders);
      } else {
        setAllOrders([]);
      }
    } catch (error) {
      setAllOrders([]);
    }
  };

  // Refresh products after add/edit/delete
  const refreshProducts = async () => {
    setIsLoading(true);
    await fetchProductsFromDatabase();
    setIsLoading(false);
  };

  // Retry fetching all data
  const handleRetry = () => {
    fetchProductsFromDatabase();
    fetchGoldRatesFromDatabase();
    fetchSiteSettingsFromDatabase();
    fetchMembersFromDatabase();
    fetchOrdersFromDatabase();
    loadWishlistFromDatabase();
    loadCartFromDatabase();
  };

  // Admin URL Detection Logic
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname;

    if (
        params.get('entry') === 'staff' || 
        path === '/admin' || path.endsWith('/admin') ||
        path === '/admin-login' || path.endsWith('/admin-login') ||
        path === '/login-admin' || path.endsWith('/login-admin')
    ) {
        setActivePage('admin-portal');
    }
  }, []);

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activePage]);

  // Handle user update from MemberProfile
  const handleUpdateUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('sparklingUser', JSON.stringify(updatedUser));
  };

  // Returns true if user is admin OR has at least one of the given permissions
  const canStaff = (...perms) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    // Handle permissions as array or JSON string
    let rawPerms = user.permissions;
    if (typeof rawPerms === 'string') { try { rawPerms = JSON.parse(rawPerms); } catch { rawPerms = []; } }
    const userPerms = Array.isArray(rawPerms) ? rawPerms : [];
    return perms.some(p => userPerms.includes(p));
  };

  const handleLogin = async (userData) => {
    setUser(userData);
    const isStaffOrAdmin = userData.role && userData.role !== 'member';
    if (isStaffOrAdmin) {
      // Redirect to first page the staff has permission for
      const perms = Array.isArray(userData.permissions) ? userData.permissions : [];
      const isAdmin = userData.role === 'admin';
      let landingPage = 'admin-dashboard'; // admin always goes to dashboard
      if (!isAdmin) {
        if (perms.includes('view_dashboard') || perms.includes('view_reports')) landingPage = 'admin-dashboard';
        else if (perms.includes('manage_products') || perms.includes('manage_stock') || perms.includes('view_products')) landingPage = 'admin-products';
        else if (perms.includes('view_orders') || perms.includes('update_order_status') || perms.includes('add_timeline') ||
                 perms.includes('verify_payments') || perms.includes('reject_payments')) landingPage = 'admin-transactions';
        else if (perms.includes('view_members'))       landingPage = 'admin-members';
        else if (perms.includes('update_gold_rates') || perms.includes('view_gold_rates')) landingPage = 'admin-pricing';
        else if (perms.includes('manage_bank_details')) landingPage = 'admin-bank-details';
        else if (perms.includes('manage_settings'))    landingPage = 'admin-settings';
        else if (perms.includes('manage_staff'))       landingPage = 'admin-staff';
      }
      setActivePage(landingPage);
    } else {
      setActivePage('home');
    }

    // Merge guest wishlist/cart into user account
    const guestId = localStorage.getItem('guest_id');
    if (guestId && userData.id) {
      try {
        await fetch(`${API_BASE_URL}/wishlist/merge`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userData.id, guest_id: guestId })
        });
        await fetch(`${API_BASE_URL}/cart/merge`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userData.id, guest_id: guestId })
        });
      } catch (e) {}
    }
    setTimeout(() => {
      loadWishlistFromDatabase();
      loadCartFromDatabase();
      fetchOrdersFromDatabase();
    }, 300);
  };

  const handleLogout = () => {
    setUser(null);
    setActivePage('home');
    setAllOrders([]);
    
    localStorage.removeItem('guest_id');
    setTimeout(() => {
      loadWishlistFromDatabase();
      loadCartFromDatabase();
    }, 500);
    
    try {
        const url = new URL(window.location.href);
        const path = window.location.pathname;
        
        if (url.searchParams.has('entry')) {
            url.searchParams.delete('entry');
        }
        
        if (
            path.endsWith('/admin') || 
            path.endsWith('/admin-login') || 
            path.endsWith('/login-admin')
        ) {
            window.history.pushState({}, '', '/');
        } else {
            window.history.pushState({}, '', url.toString());
        }
    } catch (e) {
    }
  };

  // Product Management Handlers
  const handleAddProduct = async (newProduct) => {
    setProducts(prev => [...prev, newProduct]);
    await refreshProducts();
  };

  const handleEditProduct = async (updatedProduct) => {
    setProducts(prev => prev.map(p => p.id === updatedProduct.id ? updatedProduct : p));
    await refreshProducts();
  };

  const handleDeleteProduct = async (id) => {
    setProducts(prev => prev.filter(p => p.id !== id));
    await refreshProducts();
  };

  // Rate Management Handler
  const handleUpdateRates = (newRates) => {
    setRates(newRates);
    
    const updatedProducts = products.map(product => {
      if (product.category === 'jewelry' && product.weight && product.goldType && product.karat) {
        const weightVal = parseWeight(product.weight);
        
        const matchingRate = newRates.find(rate => 
          rate.goldType === product.goldType && 
          rate.karat === product.karat
        );
        
        if (!isNaN(weightVal) && weightVal > 0 && matchingRate) {
          const newPrice = weightVal * matchingRate.pricePerGram;
          
          const isPriceOverridden = (product ).priceOverridden === true;
          if (!isPriceOverridden) {
            return { ...product, price: newPrice };
          }
        }
      }
      return product;
    });
    
    setProducts(updatedProducts);
  };

  const handleUpdateSettings = (newSettings) => {
      setSiteSettings(newSettings);
  };

  // Order Logic
  const handlePlaceOrder = async (newOrder) => {
    setAllOrders(prev => [newOrder, ...prev]);
    
    for (const item of newOrder.items) {
      if (item.quantity > 0) {
        try {
          const response = await fetch(`${API_BASE_URL}/products/update-stock`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              product_id: item.id, 
              quantity: item.quantity, 
              operation: 'decrease' 
            })
          });
          await response.json();
        } catch (error) {
        }
      }
    }
    
    const wishlistCheckout = sessionStorage.getItem('wishlistCheckout');
    
    if (wishlistCheckout) {
      try {
        const data = JSON.parse(wishlistCheckout);
        
        if (data.source === 'wishlist' && data.items && data.items.length > 0) {
          const checkedOutProductIds = data.items.map((item) => item.product.id);
          await bulkRemoveWishlistItems(checkedOutProductIds);
          sessionStorage.removeItem('wishlistCheckout');
          await loadWishlistFromDatabase();
        }
      } catch (error) {
      }
    }
    
    await refreshProducts();

    // Only clear cart if this was a cart checkout (not wishlist checkout)
    if (!wishlistCheckout) {
      setCart([]);
    }
    setDirectCheckoutItem(null);
    setWishlistCheckoutItems(null);
    sessionStorage.removeItem('directCheckout');
    fetchOrdersFromDatabase();
  };

  const handleUpdateOrder = (orderId, updates) => {
      setAllOrders(prev => prev.map(order => 
          order.id === orderId ? { ...order, ...updates } : order
      ));
  };

  // Wishlist Logic
  const toggleWishlist = async (product) => {
    const productId = product.id;

    if (wishlistProcessingRef.current.has(productId)) {
      return;
    }

    // Block adding out-of-stock products to wishlist
    const isAlreadyInWishlist = wishlist.some(item => item.id === productId);
    if (!isAlreadyInWishlist && product.stock !== undefined && product.stock <= 0) {
      showToast('This item is out of stock and cannot be added to your wishlist.', 'error');
      return;
    }

    wishlistProcessingRef.current.add(productId);

    try {
      const exists = wishlist.some(item => item.id === productId);
      const action = exists ? 'remove' : 'add';

      const success = await syncWishlistWithDatabase(product, action);

      if (!success) {
        showToast('Failed to update wishlist. Please try again.', 'error');
      }
    } catch (error) {
      showToast('Failed to update wishlist. Please try again.', 'error');
    } finally {
      wishlistProcessingRef.current.delete(productId);
    }
  };

  const isInWishlist = (id) => {
      return wishlist.some(item => item.id === id);
  };

  const updateWishlistQuantity = async (id, delta) => {
    const item = wishlist.find(i => i.id === id);
    if (!item) return;
    const newQty = Math.max(1, item.quantity + delta);

    // Block if quantity would exceed available stock
    if (delta > 0 && typeof item.stock === 'number' && newQty > item.stock) {
      showToast(`Only ${item.stock} left in stock`, 'error');
      return;
    }

    // Optimistic update
    setWishlist(prev => prev.map(i => i.id === id ? { ...i, quantity: newQty } : i));

    // Persist to DB so popup panel stays in sync
    try {
      const userId = getUserId();
      const guestId = getGuestId();
      await fetch(`${API_BASE_URL}/wishlist/update-quantity`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, guest_id: guestId, product_id: id, quantity: newQty })
      });
    } catch (e) {
    }
  };

  const toggleWishlistSelection = (id) => {
    setWishlist(prev => prev.map(item => 
      item.id === id ? { ...item, selected: !item.selected } : item
    ));
  };

  const toggleAllWishlistSelection = (select) => {
    setWishlist(prev => prev.map(item => ({ ...item, selected: select })));
  };

  const removeFromWishlist = async (ids) => {
    const itemsToRemove = wishlist.filter(item => ids.includes(item.id));
    
    let success = true;
    for (const item of itemsToRemove) {
      const result = await syncWishlistWithDatabase(item , 'remove');
      if (!result) success = false;
    }
    
    if (success) {
      await loadWishlistFromDatabase();
    } else {
      showToast('Failed to remove items. Please try again.', 'error');
    }
  };

  // Cart Logic
  const handleAddToCart = async (product, quantity) => {
    if (product.stock !== undefined && product.stock <= 0) {
      showToast('Sorry, this item is out of stock.', 'error');
      return false;
    }

    if (product.stock !== undefined && quantity > product.stock) {
      showToast(`Sorry, only ${product.stock} items available in stock.`, 'error');
      return false;
    }

    try {
      const success = await syncCartWithDatabase(product, quantity, 'add');

      if (success) {
        return true;
      } else {
        showToast('Failed to add to cart. Please try again.', 'error');
        return false;
      }
    } catch (error) {
      showToast('Connection error. Please check your network and try again.', 'error');
      return false;
    }
  };

  const handleRemoveFromCart = async (cartItemId) => {
  
    // Search in both regular cart and wishlist checkout items
    const cartToSearch = wishlistCheckoutItems || cart;
    const product = cartToSearch.find(item => 
      item.cart_id === cartItemId || 
      item.cart_id === parseInt(String(cartItemId)) ||
      item.id === cartItemId || 
      item.id === parseInt(String(cartItemId))
    );
    
    if (!product) {
      return;
    }
    
    try {
      const success = await syncCartWithDatabase(product , 0, 'remove');
      
      if (success) {
        // If removing from wishlist checkout, update that state too
        if (wishlistCheckoutItems) {
          const updated = wishlistCheckoutItems.filter(item => item.cart_id !== product.cart_id && item.id !== product.id);
          if (updated.length === 0) {
            setWishlistCheckoutItems(null);
          } else {
            setWishlistCheckoutItems(updated);
          }
        }
        await loadCartFromDatabase();
      } else {
        showToast('Failed to remove item. Please try again.', 'error');
      }
    } catch (error) {
      showToast('Connection error. Please try again.', 'error');
    }
  };

  const handleUpdateCartQty = async (cartItemId, delta) => {
    // Search in both regular cart and wishlist checkout items
    const cartToSearch = wishlistCheckoutItems || cart;
    
    // Find item by cart_id or id (handle both number and string)
    const currentItem = cartToSearch.find(item => 
      item.cart_id === cartItemId || 
      item.cart_id === parseInt(String(cartItemId)) ||
      item.id === cartItemId || 
      item.id === parseInt(String(cartItemId))
    );
    
    if (!currentItem) {
      showToast('Item not found in cart. Please refresh and try again.', 'error');
      return;
    }
    
    
    const newQuantity = Math.max(1, currentItem.quantity + delta);
    if (currentItem.stock > 0 && newQuantity > currentItem.stock) {
      showToast(`Sorry, only ${currentItem.stock} items available in stock.`, 'error');
      return;
    }

    try {
      // Use the product_id (currentItem.id) for the API call, not the cart_id
      const success = await syncCartWithDatabase(currentItem , newQuantity, 'update');
      if (success) {
        // If updating wishlist checkout items, update that state too
        if (wishlistCheckoutItems) {
          const updated = wishlistCheckoutItems.map(item =>
            (item.cart_id === currentItem.cart_id || item.id === currentItem.id)
              ? { ...item, quantity: newQuantity }
              : item
          );
          setWishlistCheckoutItems(updated);
        }
        
        // Force a small delay to ensure database is updated
        await new Promise(resolve => setTimeout(resolve, 100));
        await loadCartFromDatabase();
      } else {
        showToast('Failed to update quantity. Please try again.', 'error');
      }
    } catch (error) {
      showToast('Connection error. Please try again.', 'error');
    }
  };

  const moveToCart = async (ids) => {
    const itemsToMove = wishlist.filter(item => ids.includes(item.id));
    
    let allSuccessful = true;
    for (const item of itemsToMove) {
      const result = await handleAddToCart(item , 1);
      if (!result) {
        allSuccessful = false;
        break;
      }
    }
    
    if (allSuccessful) {
      await removeFromWishlist(ids);
    } else {
      showToast('Failed to move some items. Please try again.', 'error');
      loadWishlistFromDatabase();
      loadCartFromDatabase();
    }
  };

  const handleOpenCart = () => {
    setShowCart(true);
  };

  const handleOpenWishlist = () => {
    setShowWishlist(true);
  };

  const handleCloseCart = () => {
    setShowCart(false);
  };

  const handleCloseWishlist = () => {
    setShowWishlist(false);
  };

  return (
    React.createElement('div', { className: "min-h-screen bg-stone-50 text-stone-900 font-sans selection:bg-gold-200 selection:text-stone-900"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1440}}
      , toast && React.createElement('div', {
          className: `fixed top-6 right-6 z-[999] flex items-center gap-3 px-5 py-4 rounded-sm shadow-xl text-sm font-medium transition-all ${toast.type === 'error' ? 'bg-red-600 text-white' : 'bg-stone-900 text-white'}`,
          style: { minWidth: '280px' }
        },
        React.createElement('span', null, toast.message),
        React.createElement('button', { onClick: () => setToast(null), className: "ml-auto text-white/70 hover:text-white text-lg leading-none" }, '×')
      )
      /* Global Product Modal */
      , selectedProduct && (
        React.createElement(ProductDetailModal, { 
          product: selectedProduct,
          onClose: () => setSelectedProduct(null),
          onAddToCart: handleAddToCart,
          onToggleWishlist: toggleWishlist,
          isInWishlist: isInWishlist,
          onNavigate: (page) => {
            if (page === 'checkout' && selectedProduct) {
              // Read quantity from sessionStorage set by the modal (respects user-selected qty)
              let quantity = 1;
              try {
                const stored = sessionStorage.getItem('directCheckout');
                if (stored) {
                  const parsed = JSON.parse(stored);
                  if (parsed.product?.id === selectedProduct.id) quantity = parsed.quantity || 1;
                }
              } catch (e) {}
              const checkoutData = { product: selectedProduct, quantity };
              sessionStorage.setItem('directCheckout', JSON.stringify(checkoutData));
              setDirectCheckoutItem(checkoutData);
            }
            setActivePage(page);
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1443}}
        )
      )

      /* Wishlist Overlay */
      , showWishlist && (
        React.createElement(Wishlist, {
          onNavigate: setActivePage,
          onSelectProduct: setSelectedProduct,
          user: user,
          onClose: handleCloseWishlist,
          onWishlistCheckout: (items) => {
            // Store checkout data but DO NOT remove items yet
            const checkoutData = {
              items: items,
              source: 'wishlist',
              timestamp: Date.now()
            };
            sessionStorage.setItem('wishlistCheckout', JSON.stringify(checkoutData));
            // Items will be removed after successful checkout in handlePlaceOrder
            // const productIds = items.map(item => item.product.id);
            // bulkRemoveWishlistItems(productIds); // REMOVED - items should only be removed after successful order
            if (!user) { setActivePage('auth'); } else { setActivePage('checkout'); }
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1465}}
        )
      )

      /* Navbar */
      , activePage !== 'auth' && activePage !== 'admin-portal' && activePage !== 'register' && (
        React.createElement(Navbar, {
            onNavigate: setActivePage,
            user: user,
            onLogout: handleLogout,
            activePage: activePage,
            wishlist: wishlist,
            onOpenWishlist: handleOpenWishlist,
            categories: [...new Set(products.map(p => p.category).filter(Boolean))].sort(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 1488}}
        )
      )

      , React.createElement('main', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1498}}
        , activePage === 'home' && (
          React.createElement('div', { className: "page-transition", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1500}}
            , React.createElement(Hero, { onNavigate: setActivePage, user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1501}} )

            , React.createElement('div', { className: "w-full h-16 bg-gradient-to-b from-stone-50/0 to-stone-50"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1503}})

            , React.createElement('div', { id: "collections", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1505}}
              , React.createElement(FeaturedCollection, { onNavigate: setActivePage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1506}} )
            )

            , React.createElement('div', { id: "shop", className: "py-20 bg-white" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1509}}
              , React.createElement('div', { className: "text-center mb-12" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1510}}
                , React.createElement('span', { className: "text-gold-600 text-[10px] tracking-[0.3em] uppercase font-bold"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1511}}, "Curated For You"  )
                , React.createElement('h2', { className: "text-3xl font-serif text-stone-900 mt-3"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1512}}, "Browse Categories" )
              )
              , React.createElement(GridCategories, { onNavigate: setActivePage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1514}} )
            )

            , React.createElement('div', { id: "maison", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1517}}
              , React.createElement(VideoSection, { onNavigate: setActivePage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1518}} )
            )

            , apiError && (
              React.createElement('div', { className: "bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 mx-4 mb-4 rounded-sm"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1522}}
                , React.createElement('p', { className: "text-sm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1523}}, apiError)
                , React.createElement('p', { className: "text-xs mt-1" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1524}}, "Showing sample products"  )
                , React.createElement('button', { 
                  onClick: handleRetry,
                  className: "text-xs underline mt-2 hover:text-yellow-600"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1525}}
, "Retry Connection"

                )
                , dataSources.products && (
                  React.createElement('p', { className: "text-xs mt-1 text-stone-500"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1532}}, "Using "
                     , dataSources.products, " data"
                  )
                )
              )
            )

            /* Company Info Section - Replaces moving gold prices */
            , React.createElement('div', { className: "bg-stone-100 py-6 border-y border-stone-200"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1540}}
              , React.createElement('div', { className: "max-w-7xl mx-auto px-6"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1541}}
                , React.createElement('div', { className: "flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left"       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1542}}
                  , React.createElement('div', { className: "flex items-center gap-3"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1543}}
                    , React.createElement('div', { className: "w-10 h-10 rounded-full bg-gold-100 flex items-center justify-center text-gold-600 flex-shrink-0"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1544}}
                      , React.createElement('svg', { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 24 24"   , fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1545}}
                        , React.createElement('path', { d: "M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1546}})
                        , React.createElement('circle', { cx: "12", cy: "12", r: "3", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1547}})
                      )
                    )
                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1550}}
                      , React.createElement('p', { className: "text-[10px] uppercase tracking-widest text-stone-500 font-bold"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1551}}, "Authenticity Guaranteed" )
                      , React.createElement('p', { className: "text-xs text-stone-600" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1552}}, "All items are 100% genuine and certified"      )
                    )
                  )

                  , React.createElement('div', { className: "flex items-center gap-3"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1556}}
                    , React.createElement('div', { className: "w-10 h-10 rounded-full bg-gold-100 flex items-center justify-center text-gold-600 flex-shrink-0"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1557}}
                      , React.createElement('svg', { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 24 24"   , fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1558}}
                        , React.createElement('rect', { x: "2", y: "7", width: "20", height: "14", rx: "2", ry: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1559}})
                        , React.createElement('path', { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1560}})
                      )
                    )
                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1563}}
                      , React.createElement('p', { className: "text-[10px] uppercase tracking-widest text-stone-500 font-bold"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1564}}, "Secure Shipping" )
                      , React.createElement('p', { className: "text-xs text-stone-600" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1565}}, "Insured delivery nationwide & worldwide"    )
                    )
                  )

                  , React.createElement('div', { className: "flex items-center gap-3"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1569}}
                    , React.createElement('div', { className: "w-10 h-10 rounded-full bg-gold-100 flex items-center justify-center text-gold-600 flex-shrink-0"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1570}}
                      , React.createElement('svg', { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 24 24"   , fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1571}}
                        , React.createElement('path', { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1572}})
                      )
                    )
                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1575}}
                      , React.createElement('p', { className: "text-[10px] uppercase tracking-widest text-stone-500 font-bold"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1576}}, "Lifetime Service" )
                      , React.createElement('p', { className: "text-xs text-stone-600" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1577}}, "Cleaning, inspection & maintenance"   )
                    )
                  )

                  , React.createElement('div', { className: "flex items-center gap-3"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1581}}
                    , React.createElement('div', { className: "w-10 h-10 rounded-full bg-gold-100 flex items-center justify-center text-gold-600 flex-shrink-0"        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1582}}
                      , React.createElement('svg', { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 24 24"   , fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1583}}
                        , React.createElement('path', { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1584}})
                        , React.createElement('circle', { cx: "12", cy: "7", r: "4", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1585}})
                      )
                    )
                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1588}}
                      , React.createElement('p', { className: "text-[10px] uppercase tracking-widest text-stone-500 font-bold"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1589}}, "Expert Team" )
                      , React.createElement('p', { className: "text-xs text-stone-600" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 1590}}, "GIA certified gemologists on staff"    )
                    )
                  )
                )
              )
            )
          )
        )

        /* Shop Pages */
        , activePage === 'shop' && (
          React.createElement(Shop, { 
            initialCategory: "all",
            onNavigate: setActivePage,
            products: products,
            wishlist: wishlist,
            onToggleWishlist: toggleWishlist,
            onAddToCart: handleAddToCart,
            onSelectProduct: setSelectedProduct,
            user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1601}}
          )
        )

        , activePage === 'collections' && (
          React.createElement(Shop, { 
            initialCategory: "jewelry",
            onNavigate: setActivePage,
            products: products,
            wishlist: wishlist,
            onToggleWishlist: toggleWishlist,
            onAddToCart: handleAddToCart,
            onSelectProduct: setSelectedProduct,
            user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1614}}
          )
        )

        , activePage === 'bags' && (
          React.createElement(Shop, {
            initialCategory: "bags",
            onNavigate: setActivePage,
            products: products,
            wishlist: wishlist,
            onToggleWishlist: toggleWishlist,
            onAddToCart: handleAddToCart,
            onSelectProduct: setSelectedProduct,
            user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1627}}
          )
        )

        , activePage === 'footware' && (
          React.createElement(Shop, {
            initialCategory: "footware",
            onNavigate: setActivePage,
            products: products,
            wishlist: wishlist,
            onToggleWishlist: toggleWishlist,
            onAddToCart: handleAddToCart,
            onSelectProduct: setSelectedProduct,
            user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1627}}
          )
        )

        , activePage === 'jewelry' && (
          React.createElement(Shop, {
            initialCategory: "jewelry",
            onNavigate: setActivePage,
            products: products,
            wishlist: wishlist,
            onToggleWishlist: toggleWishlist,
            onAddToCart: handleAddToCart,
            onSelectProduct: setSelectedProduct,
            user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1627}}
          )
        )

        , activePage === 'fragrances' && (
          React.createElement(Shop, { 
            initialCategory: "fragrances",
            onNavigate: setActivePage,
            products: products,
            wishlist: wishlist,
            onToggleWishlist: toggleWishlist,
            onAddToCart: handleAddToCart,
            onSelectProduct: setSelectedProduct,
            user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1640}}
          )
        )

        /* Checkout Page */
        , activePage === 'checkout' && (
          React.createElement(Checkout, {
              cart: wishlistCheckoutItems || cart,
              onPlaceOrder: handlePlaceOrder,
              onNavigate: setActivePage,
              onSelectProduct: setSelectedProduct,
              onUpdateCartQty: handleUpdateCartQty,
              onRemoveFromCart: handleRemoveFromCart,
              onClearCart: () => {
                setCart([]);
                setWishlistCheckoutItems(null);
              },
              directCheckoutItem: directCheckoutItem,
              user: user,
              onRefreshWishlist: loadWishlistFromDatabase, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1654}}
          )
        )

        /* Payment Proof Upload */
        , activePage === 'upload-proof' && (
          React.createElement(PaymentProofUpload, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1673}} )
        )

        /* Other Pages */
        , activePage === 'contact' && React.createElement(Contact, { settings: siteSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1677}} )
        , activePage === 'services' && React.createElement(Services, { onNavigate: setActivePage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1678}} )
        , activePage === 'about' && React.createElement(About, { onNavigate: setActivePage, settings: siteSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1679}} )
        , activePage === 'privacy-policy' && React.createElement(PrivacyPolicy, { onNavigate: setActivePage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1680}} )
        , activePage === 'auth' && React.createElement(Auth, { onNavigate: setActivePage, onLogin: handleLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1681}} )
        , activePage === 'register' && React.createElement(Auth, { onNavigate: setActivePage, onLogin: handleLogin, initialMode: "register", __self: this, __source: {fileName: _jsxFileName, lineNumber: 1682}} )
        , activePage === 'admin-portal' && React.createElement(Auth, { onNavigate: setActivePage, onLogin: handleLogin, initialAdmin: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1683}} )
        , activePage === 'reset-password' && React.createElement(ResetPassword, { onNavigate: setActivePage, token: resetToken, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1684}} )

        , activePage === 'profile' && user && (
          React.createElement(MemberProfile, {
              user: user,
              onNavigate: setActivePage,
              onLogout: handleLogout,
              onUpdateUser: handleUpdateUser,
              initialTab: "overview",
              wishlist: wishlist,
              onUpdateWishlistQuantity: updateWishlistQuantity,
              onToggleWishlistSelection: toggleWishlistSelection,
              onToggleAllWishlistSelection: toggleAllWishlistSelection,
              onRemoveFromWishlist: removeFromWishlist,
              onMoveToCart: moveToCart,
              onSelectProduct: setSelectedProduct,
              onRefreshWishlist: loadWishlistFromDatabase,
              orders: allOrders,
              onUpdateOrder: handleUpdateOrder,
              onRefreshOrders: fetchOrdersFromDatabase, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1687}}
          )
        )

        , activePage === 'orders' && user && (
          React.createElement(MemberProfile, {
              user: user,
              onNavigate: setActivePage,
              onLogout: handleLogout,
              onUpdateUser: handleUpdateUser,
              initialTab: "orders",
              wishlist: wishlist,
              onUpdateWishlistQuantity: updateWishlistQuantity,
              onToggleWishlistSelection: toggleWishlistSelection,
              onToggleAllWishlistSelection: toggleAllWishlistSelection,
              onRemoveFromWishlist: removeFromWishlist,
              onMoveToCart: moveToCart,
              onSelectProduct: setSelectedProduct,
              onRefreshWishlist: loadWishlistFromDatabase,
              orders: allOrders,
              onUpdateOrder: handleUpdateOrder,
              onRefreshOrders: fetchOrdersFromDatabase, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1706}}
          )
        )

        /* Admin Pages — role guard handled by routing; API enforces per-permission data access */
        , activePage === 'admin-dashboard' && user && (user.role === 'admin' || user.role === 'staff') && canStaff('view_dashboard', 'view_reports') && React.createElement(AdminDashboard, { onNavigate: setActivePage, user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1725}} )

        , (activePage === 'admin-products' || activePage === 'admin-add-product') && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminProducts, {
              products: products,
              rates: rates,
              onAdd: handleAddProduct,
              onEdit: handleEditProduct,
              onDelete: handleDeleteProduct,
              onNavigate: setActivePage,
              initialView: activePage === 'admin-add-product' ? 'form' : 'list',
              onRefresh: refreshProducts,
              user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1728}}
          )
        )

        , activePage === 'admin-pricing' && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminPricing, {
              rates: rates,
              onUpdateRates: handleUpdateRates,
              onNavigate: setActivePage,
              user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1741}}
          )
        )

        , activePage === 'admin-profile' && user && (user.role === 'admin' || user.role === 'staff') && React.createElement(AdminProfile, { onNavigate: setActivePage, user: user, onUpdateUser: handleUpdateUser, settings: siteSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1748}} )

        , activePage === 'admin-settings' && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminSettings, {
              settings: siteSettings,
              onUpdateSettings: handleUpdateSettings,
              onNavigate: setActivePage,
              user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1751}}
          )
        )

        , activePage === 'admin-members' && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminMembers, {
              members: members,
              onNavigate: setActivePage,
              user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1759}}
          )
        )

        , activePage === 'admin-transactions' && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminTransactions, {
              orders: allOrders,
              onUpdateOrder: handleUpdateOrder,
              onNavigate: setActivePage,
              user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1766}}
          )
        )

        , activePage === 'admin-bank-details' && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminBankDetails, { onNavigate: setActivePage, user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1774}} )
        )

        , activePage === 'admin-staff' && user && (user.role === 'admin' || user.role === 'staff') && (
          React.createElement(AdminStaff, { onNavigate: setActivePage, user: user })
        )

      )

      /* Footer */
      , activePage !== 'auth' && activePage !== 'admin-portal' && activePage !== 'register' && (
        React.createElement(React.Fragment, null
          , React.createElement(Footer, { settings: siteSettings, onNavigate: setActivePage, user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 1782}} )
          , React.createElement(Concierge, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1783}} )
          , React.createElement(ScrollToTop, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 1784}} )
        )
      )
    )
  );
}

export default App;